// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__3I6iO","logo-button":"logo_logo-button__ywRkU"};